import React from 'react'
import PropTypes from 'prop-types'

import { CircularProgress, Typography, makeStyles } from '@material-ui/core'

import styles from './styles'

const useStyles = makeStyles(styles)

const Loader = ({ open, align = 'center', title, message }) => {
  const classes = useStyles()

  if (!open) {
    return null
  }

  return (
    <div className={classes.root} style={{ alignItems: align }}>
      <div className={classes.container}>
        <CircularProgress size={40} className={classes.progress} />
        <Typography variant="h4" color="primary" align="center" gutterBottom>
          {title}
        </Typography>
        <Typography color="textSecondary" align="center">
          {message}
        </Typography>
      </div>
    </div>
  )
}

Loader.propTypes = {
  open: PropTypes.bool,
  align: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),
  title: PropTypes.string,
  message: PropTypes.string,
}

export default Loader
